<div class="header-bar">
  <h1>Customer Invoice Report Settings</h1>
</div>
<div class="content-container">
  <p-card>
    <div>
      <organisation-select-list
        [minTextLength]="1"
        [selectedOrganisationId]="customerorgId"
        *ngIf="isVmeMode"
        (valueChange)="onOrganisationChange($event)"
        [organisationTypeId]="2"
      >
      </organisation-select-list>
    </div>
  </p-card>
  <div *ngIf="customerInvoiceReportSetting" class="mt-2">
    <p-table
      *ngIf="customerInvoiceReportSetting"
      #dt
      selectionMode="single"
      [value]="customerInvoiceReportSetting"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="customerInfoiceReportItem.displayName">Field</th>
          <th pSortableColumn="customerInfoiceReportItem.description">Description</th>
          <th pSortableColumn="includeInReport">Include In Report</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>{{ item.customerInvoiceReportItem.displayName }}</td>
          <td>{{ item.customerInvoiceReportItem.description }}</td>
          <td style="text-align: center">
            <p-inputSwitch [(ngModel)]="item.includeInReport"></p-inputSwitch>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- DATATABLES DEPRECATED --
    <p-dataTabl *ngIf="customerInvoiceReportSetting" #dt selectionMode="single" [value]="customerInvoiceReportSetting"
    [responsive]="true" [rowHover]="true" [resizableColumns]="true" [loading]="isLoading">
    <p-column field="customerInvoiceReportItem.displayName" header="Field" [sortable]="tru" [editable]="false" [style]="{'width':'20%'}">
    </p-column>
    <p-column field="customerInvoiceReportItem.description" header="Description" [sortable]="tru" [editable]="false" [style]="{'width':'50%'}">
    </p-column>
    <p-column field="includeInReport" header="Include in Report" [sortable]="tru" [editable]="tru" styleClass="text-center" [style]="{'width':'10%'}">
      <ng-template let-setting="rowData" pTemplate type="body" >
        <p-inputSwitch [(ngModel)]="setting.includeInReport"></p-inputSwitch>
    </ng-template>
    </p-column>
  </p-dataTable>
  --->

    <p>
      <b
        >Additional Cost items will be automatically included in each invoice report if there are
        any for the Task</b
      >
    </p>
  </div>
  <div class="footerPanel ui-grid-row" *ngIf="customerInvoiceReportSetting">
    <button
      pButton
      type="button"
      label="Cancel"
      icon="pi pi-times"
      class="ui-button-secondary pull-right"
      (click)="onOrganisationChange(customerorgId)"
    ></button>
    <button
      pButton
      type="button"
      label="Save"
      icon="pi pi-check"
      style="margin-right: 0.25em"
      class="pull-right"
      (click)="saveSettings()"
    ></button>
  </div>
</div>
